import Login from "@/views/login/Login.vue"
import ForgotPassword from "@/views/login/ForgotPassword.vue"
import ResetPassword from "@/views/login/ResetPassword.vue"
import Register from "@/views/login/Register.vue"
import Verify from "@/views/login/Verify.vue"
import LoginLayout from "@/views/login/LoginLayout.vue"
import VerifyEmail from "@/views/login/VerifyEmail.vue"
import BusinessInfo from "@/views/login/BusinessInfo.vue"
import Collaborator from "@/views/login/Collaborator.vue"

const routes = [
  {
    path: "/:lang",
    component: LoginLayout,
    children: [
      {
        path: "",
        redirect: "login",
        meta: {
          requireAuth: false,
          auth: 0
        }
      },
      {
        path: "login",
        name: "Login",
        meta: {
          title: "Auth.__Login",
          requireAuth: false,
          auth: 0
        },
        component: Login,
        props: route => ({
          ...route.params
        })
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        meta: {
          title: "Auth.__ForgotPassword",
          requireAuth: false,
          auth: 0
        },
        component: ForgotPassword
      },
      {
        path: "reset-password/",
        name: "ResetPassword",
        meta: {
          title: "Auth.__ResetYourPassword",
          requireAuth: false,
          auth: 0
        },
        component: ResetPassword
      },
      {
        path: "signup",
        name: "Signup",
        meta: {
          title: "Auth.__RegisterForFree",
          requireAuth: false,
          auth: 0
        },
        component: Register
      },
      {
        path: "verify/:uid",
        name: "Verify",
        meta: {
          title: "Auth.__VerifyEmail",
          requireAuth: false,
          auth: 0
        },
        component: Verify
      },
      {
        path: "business-info",
        name: "BusinessInfo",
        meta: {
          title: "Auth.__FillBizInfo",
          requireAuth: false,
          auth: 0
        },
        component: BusinessInfo
      },
      {
        path: "verify-your-account",
        name: "VerifyEmail",
        meta: {
          title: "Auth.__VerifyEmail",
          requireAuth: false,
          auth: 0
        },
        component: VerifyEmail,
        props: route => ({
          ...route.params
        })
      },
      {
        path: "collaborator",
        name: "Collaborator",
        meta: {
          title: "Collaborators.__BecomeMember",
          requireAuth: false,
          auth: 0,
          back2Auth: false
        },
        component: Collaborator,
        props: route => ({
          ...route.params
        })
      }
    ]
  }
]

export default routes
